import { HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentsService } from 'src/app/services/documents.service';
import { GlobalService } from 'src/app/services/global.service';
import { RejectUserDocumentComponent } from '../reject-user-document/reject-user-document.component';

@Component({
  selector: 'app-user-student-photo',
  templateUrl: './user-student-photo.component.html',
  styleUrls: ['./user-student-photo.component.css']
})
export class UserStudentPhotoComponent implements OnInit {
  @Input() user_id: number;
  @Output() status = new EventEmitter<Object>();
  data: any;

  userStudentPhoto: any;
  userStudentPhotoValue: number;
  userStudentPhotoMode: string = 'indeterminate';

  constructor(
    private documentService: DocumentsService,
    private _sanitizer: DomSanitizer,
    public globalService: GlobalService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.documentService.getUserStudentPhoto(this.user_id).subscribe((result) => {
      
      this.data = result.data;

      this.documentService.getMFile(result.data.image).subscribe(event => {
        if (event.type === HttpEventType.DownloadProgress) {
          this.userStudentPhotoMode = 'determinate';
          this.userStudentPhotoValue = Math.round(100 * event.loaded / event.total);
        }
        if (event.type === HttpEventType.Response) {
          let reader = new FileReader();
          reader.addEventListener("load", () => {
            this.userStudentPhoto = reader.result;
          }, false);
          reader.readAsDataURL(event.body);
        }
      });

    }, this.globalService.handleError);
  }

  
  panelAccept(): void {
    this.documentService.setStudentPhotoStatus(this.data.id, 'Approved').subscribe(result => {
        this.data = result.data;
        this.status.emit({process: 'student_license', status: 'Approved'});
      }, this.globalService.handleError);
  }

  panelReject(): void {
    this.dialog.open(RejectUserDocumentComponent, {
      data: {
        model: 'StudentCard',
        selected: this.data.rejected_reason
      },
      width: '500px',
      maxWidth: '90%'
    }).afterClosed().subscribe(res => {
      if(res === undefined) return;
      
      this.documentService.setStudentPhotoRejected(this.data.id, res).subscribe(result => {
        this.status.emit({process: 'student_license', status: 'Rejected'});
        this.data = result.data;
      }, this.globalService.handleError);

      console.log(res);
    });
  }


}
